import i18next from "i18next";
import StatusPill from "../../../components/Common/ListParts/StatusPill";
import { formatDate } from "../../../../utils/DateUtils";
import { convertDoubleToCurrencyPTBR } from "../../../../utils/ConverterUtils";

const formatCurrency = convertDoubleToCurrencyPTBR;

// Quem consumiu. É de quem o valor sai, então vem primeiro.
const employeeRenderer = (params) => params.data?.employee?.name || '-';

const productRenderer = (params) => params.data?.product?.name || '-';

/** Quantidade inteira sem casas; fração só aparece quando existe. */
const quantityRenderer = (params) => {
    const amount = Number(params.data?.quantity || 0);
    return Number.isInteger(amount) ? String(amount) : amount.toFixed(2).replace('.', ',');
};

// Preço aplicado e se foi o normal ou o de custo: explica por que o mesmo item varia de valor
// de um lançamento para outro.
const priceRenderer = (params) => {
    if (!params.data) {
        return '-';
    }
    const type = String(params.data.priceType || 'NORMAL').toLowerCase();
    return `${formatCurrency(params.data.unitPrice)} (${i18next.t(`cash_flow.consumption_price_${type}`)})`;
};

const totalRenderer = (params) => formatCurrency(params.data?.total);

// Dia do consumo, que decide em qual período do extrato ele é descontado.
const dateRenderer = (params) => params.data?.consumptionDate ? formatDate(params.data.consumptionDate) : '-';

/** Situação com cor: é por ela que o gestor encontra o que ainda falta acertar. */
const statusRenderer = (params) => {
    const status = params.data?.consumptionStatus;
    if (!status) {
        return '-';
    }
    const key = status.toLowerCase();
    return (
        <StatusPill tone={key}>
            {i18next.t(`cash_flow.consumption_status_${key}`)}
        </StatusPill>
    );
};

const paymentRenderer = (params) => params.data?.paymentMethod
    ? i18next.t(params.data.paymentMethod.toLowerCase())
    : '-';

const branchRenderer = (params) => params.data?.branch?.name || '-';

const registeredByRenderer = (params) => params.data?.registeredBy?.name || '-';

// Colunas do grid de consumo da equipe.
export const Columns = [
    {
        headerName: 'employee',
        field: 'employee.name',
        cellRenderer: employeeRenderer,
        sortable: false,
        width: 200
    },
    {
        headerName: 'product',
        field: 'product.name',
        cellRenderer: productRenderer,
        sortable: false,
        width: 200
    },
    {
        headerName: 'quantity',
        field: 'quantity',
        cellRenderer: quantityRenderer,
        width: 130
    },
    {
        headerName: 'cash_flow.consumption_price',
        field: 'unitPrice',
        cellRenderer: priceRenderer,
        width: 160
    },
    {
        headerName: 'total',
        field: 'total',
        cellRenderer: totalRenderer,
        width: 120
    },
    {
        headerName: 'date',
        field: 'consumptionDate',
        cellRenderer: dateRenderer,
        width: 120
    },
    {
        headerName: 'status',
        field: 'consumptionStatus',
        cellRenderer: statusRenderer,
        width: 140
    },
    {
        headerName: 'payment_method',
        field: 'paymentMethod',
        cellRenderer: paymentRenderer,
        width: 200
    },
    {
        headerName: 'branch',
        field: 'branch.name',
        cellRenderer: branchRenderer,
        sortable: false,
        width: 160
    },
    {
        headerName: 'cash_flow.consumption_registered_by',
        field: 'registeredBy.name',
        cellRenderer: registeredByRenderer,
        sortable: false,
        width: 180
    }
];
